
.connectBanner {
  width: 100%;
  border-radius: 10px;
  background-color: var(--static-background-inverse-standard);
  color: var(--static-text-inverse-strong);
  margin-bottom: 20px;
  padding-right: 20px;
}
